import { useContext } from 'react';
import { useInView } from 'react-intersection-observer';
import { useSupportsNativeLazyLoading } from '../utils/hooks/useSupportsNativeLazyLoading';
import LazyContext from './LazyContext';
export function useLazyLoading(inDumbo = false) {
    const enableLazyLoading = useContext(LazyContext);
    const supportsNativeLazy = useSupportsNativeLazyLoading();
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0,
        rootMargin: '50% 0% 50% 0%'
    });
    return {
        enableLazyLoading,
        supportsNativeLazy,
        ref,
        inView
    };
}

//# sourceMappingURL=useLazyLoading.js.map